<template>
    <v-col align="start" md="8">
      <!-- <v-col>
        <v-icon large class="primary--text" @click="reload()">mdi-close-circle</v-icon>
      </v-col>
      <v-row>
        <v-col align="start">
          <h1 class="mb-4">Select service type</h1>
        </v-col>
      </v-row> -->
      <v-row no-gutters class="btn-group">
        <v-col cols="5">
          <v-btn 
            class="primary btn"  
            height="45"
            style="border-radius: 30px;"
            v-on:click="goBack">Go back
          </v-btn>
        </v-col>
      </v-row>
      <br/>
      <v-container>
        <v-row class="mb-2" justify="start" align="start">
          <v-col>
            <v-select
              :items="services"
              v-model="selectedService"
              label="Select type of furniture:"
              chips
            ></v-select>
            <v-select
              :items="trucks"
              :disabled="!selectedService"
              item-text="name"
              return-object
              v-model="selectedTruck"
              label="Select truck size:"
              chips
            ></v-select>
            <v-text-field type="number" label="Mobile number eg: 0671234567" v-model="mobile"></v-text-field>
            <v-text-field label="Enter your email address" v-model="emailAddress"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn 
                  class="primary btn"  
                  height="45"
                  style="border-radius: 30px;"
                  v-on:click="proceed">Proceed
                </v-btn>
            </v-col>
        </v-row>
      </v-container>
    </v-col>
  </template>
  
  <script>
  export default {
    name: "ServicesBook",
    components:{
    },
    props: {
        goBack: Function
    },
    data() {
      return {
        selectedService: null,
        selectedTruck: null,
        emailAddress: null,
        mobile: null,
      }
    },
    computed: {
      services() {
        return this.$store.state.quote.service_type.map(service => service.name);
      },
      trucks() {
        return this.$store.state.quote.service_type
          .find(service => service.name === this.selectedService)?.vehicles;
      }
    },
    watch: {

    },
    methods: {
      proceed(){
        this.$emit("proceed", {
          service: this.selectedService,
          truck: this.selectedTruck,
          emailAddress: this.emailAddress,
          mobile: this.mobile,
        })
      },
      reload(){
        this.$router.go();
      },

    },
    mounted() {
    }
  }
  </script>
  
  <style scoped>
  .btn{
    width: 200px;
  }
  @media screen and (max-width: 550px){
    .btn-group{
      display: block;
    }
    .btn{
      margin-bottom: 0.5cm;
    }
  
  }
  
  </style>